<template>
    <div class="main-div">
        <div class="header-div">
            <div class="title-div">
                <div class="icon-text-header">
                    <div class="icon-div">
                        <svg xmlns="http://www.w3.org/2000/svg" width="380" height="380" viewBox="0 0 480 480" fill="none" class="pattern" opacity="0.4">
                            <defs><clipPath id="clip-circle"><rect x="190" y="190" width="240" height="240" /></clipPath></defs>
                            <g clip-path="url(#clip-circle)">
                                <circle cx="240" cy="240" r="60" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="92" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="124" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="156" stroke="#E4E4E7" />
                            </g>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                            <path d="M18.25 0.25H1.75C1.35218 0.25 0.970644 0.408035 0.68934 0.68934C0.408035 0.970644 0.25 1.35218 0.25 1.75V14.5C0.25 14.8978 0.408035 15.2794 0.68934 15.5607C0.970644 15.842 1.35218 16 1.75 16H3.25V17.5C3.25 17.6989 3.32902 17.8897 3.46967 18.0303C3.61032 18.171 3.80109 18.25 4 18.25C4.19891 18.25 4.38968 18.171 4.53033 18.0303C4.67098 17.8897 4.75 17.6989 4.75 17.5V16H15.25V17.5C15.25 17.6989 15.329 17.8897 15.4697 18.0303C15.6103 18.171 15.8011 18.25 16 18.25C16.1989 18.25 16.3897 18.171 16.5303 18.0303C16.671 17.8897 16.75 17.6989 16.75 17.5V16H18.25C18.6478 16 19.0294 15.842 19.3107 15.5607C19.592 15.2794 19.75 14.8978 19.75 14.5V1.75C19.75 1.35218 19.592 0.970644 19.3107 0.68934C19.0294 0.408035 18.6478 0.25 18.25 0.25ZM18.25 14.5H1.75V1.75H18.25V7.75H16.6863C16.4982 6.63745 15.899 5.63615 15.0075 4.94452C14.116 4.25289 12.9972 3.9214 11.8729 4.01576C10.7485 4.11012 9.70059 4.62343 8.93683 5.45397C8.17307 6.28451 7.74919 7.37167 7.74919 8.5C7.74919 9.62833 8.17307 10.7155 8.93683 11.546C9.70059 12.3766 10.7485 12.8899 11.8729 12.9842C12.9972 13.0786 14.116 12.7471 15.0075 12.0555C15.899 11.3639 16.4982 10.3625 16.6863 9.25H18.25V14.5ZM13.5475 7.75C13.3824 7.46404 13.1276 7.24054 12.8225 7.11418C12.5174 6.98782 12.1792 6.96565 11.8602 7.05111C11.5413 7.13657 11.2594 7.32489 11.0584 7.58686C10.8574 7.84882 10.7485 8.1698 10.7485 8.5C10.7485 8.8302 10.8574 9.15118 11.0584 9.41314C11.2594 9.67511 11.5413 9.86343 11.8602 9.94889C12.1792 10.0344 12.5174 10.0122 12.8225 9.88582C13.1276 9.75946 13.3824 9.53596 13.5475 9.25H15.1562C14.9737 9.95699 14.5396 10.5731 13.9352 10.983C13.3309 11.3928 12.5979 11.5681 11.8735 11.4761C11.1491 11.3841 10.4832 11.0311 10.0005 10.4832C9.51782 9.93529 9.25151 9.23018 9.25151 8.5C9.25151 7.76982 9.51782 7.0647 10.0005 6.51683C10.4832 5.96895 11.1491 5.61592 11.8735 5.52391C12.5979 5.43191 13.3309 5.60724 13.9352 6.01705C14.5396 6.42686 14.9737 7.04301 15.1562 7.75H13.5475Z" fill="#181D27" />
                        </svg>
                    </div>
                    <div>
                        <div class="title-section">
                            <p>Add Email</p>
                        </div>
                        <p class="sub-title">Enter the email address you'd like to add to your Identity Vault</p>
                    </div>
                </div>
                <div class="title-wrapper">
                    <div class="divider"></div>
                    <prime-input-text
                        v-model="emailInput"
                        class="w-full"
                        placeholder="johndoe@email.com"
                        @keyup.enter="sendVerificationCode"
                    />
                    <div v-if="emailInput.trim() !== '' && !isValidEmail(emailInput.trim())" class="validation-message">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.375 6.25C9.375 6.08424 9.44085 5.92527 9.55806 5.80806C9.67527 5.69085 9.83424 5.625 10 5.625C10.1658 5.625 10.3247 5.69085 10.4419 5.80806C10.5592 5.92527 10.625 6.08424 10.625 6.25V10.625C10.625 10.7908 10.5592 10.9497 10.4419 11.0669C10.3247 11.1842 10.1658 11.25 10 11.25C9.83424 11.25 9.67527 11.1842 9.55806 11.0669C9.44085 10.9497 9.375 10.7908 9.375 10.625V6.25ZM10 14.375C9.81458 14.375 9.63333 14.32 9.47916 14.217C9.32499 14.114 9.20482 13.9676 9.13387 13.7963C9.06291 13.625 9.04434 13.4365 9.08052 13.2546C9.11669 13.0727 9.20598 12.9057 9.33709 12.7746C9.4682 12.6435 9.63525 12.5542 9.81711 12.518C9.99896 12.4818 10.1875 12.5004 10.3588 12.5714C10.5301 12.6423 10.6765 12.7625 10.7795 12.9167C10.8825 13.0708 10.9375 13.2521 10.9375 13.4375C10.9375 13.6861 10.8387 13.9246 10.6629 14.1004C10.4871 14.2762 10.2486 14.375 10 14.375Z"
                                fill="#D92D20"
                            />
                        </svg>
                        <span> Please enter a valid email address </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-email-footer">
            <div class="footer-actions">
                <prime-button @click="closeDialog" class="p-btn-root_secondary" label="Cancel" />

                <prime-button
                    label="Send Verification Code"
                    variant="primary"
                    @click="sendVerificationCode"
                    :loading="isSendingVerificationCode"
                    :disabled="emailInput.trim() === '' || !isValidEmail(emailInput.trim())"
                />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import { useVaultStore } from '~/stores/person/vault/vault';

const emailInput = ref('');
const { isValidEmail } = useUtils();

const dialogRef = getDialogRef(ModalNames.ADD_EMAIL);
const closeDialog = () => {
    dialogRef.value.close();
};

// Get modal data if provided
const modalData = computed(() => dialogRef.value?.data || {});

// Watch for modal data changes and prefill
watch(() => modalData.value?.email, (emailData) => {
    if (emailData && typeof emailData === 'string') {
        emailInput.value = emailData;
    }
}, { immediate: true });

const personStore = usePersonStore();
const vault_store = useVaultStore();
const isSendingVerificationCode = ref(false);

const sendVerificationCode = async () => {
    if (emailInput.value === '') return;
    isSendingVerificationCode.value = true;

    try {
        // Pass exposure data to the verification modal if this came from an exposure
        const additionalData = modalData.value?.fromExposure ? {
            fromExposure: modalData.value.fromExposure,
            exposureData: modalData.value.exposureData
        } : undefined;

        await personStore.sendEmailVerificationCode(emailInput.value, false, additionalData);
        isSendingVerificationCode.value = false;
        dialogRef.value.close();
    } catch (error) {
        isSendingVerificationCode.value = false;
        return;
    }
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-xl sm:w-full w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
.title-div {
    @apply flex flex-col p-6 pb-0 items-start gap-1 self-stretch w-full;
}
.icon-text-header{
    @apply flex flex-row items-start gap-4 items-start w-full ;
}
.icon-div {
    @apply relative flex w-12 h-12 p-3 justify-center items-center rounded-full bg-gray-100;
}
.title-wrapper {
    @apply flex flex-col items-start gap-1 sm:flex-1 sm:w-auto w-full sm:pl-16;
}
.title-section {
    @apply self-stretch flex flex-row justify-between relative;

    p {
        @apply text-zinc-950 font-inter text-lg font-semibold leading-7;
    }
}
.close-icon {
    @apply flex justify-center items-center rounded-lg text-gray-400 cursor-pointer;
}
.sub-title {
    @apply text-zinc-600 font-inter text-sm font-normal leading-5;
}
.pattern {
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
}
.divider {
    @apply h-px bg-zinc-300 mt-4 mb-3.5 w-full;
}
.add-email-footer {
    @apply flex flex-col justify-center items-end self-stretch pt-8;

    .footer-actions {
        @apply flex justify-end items-center gap-3 flex-1 px-6 pb-6 ;
    }
}
.validation-message {
    @apply flex gap-1 mt-1;

    span {
        @apply text-red-600 font-inter text-sm font-normal leading-5;
    }
}
</style>
